import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";

interface ItemProps {
  hover?: string;
  bg?: string;
}

interface PropsAnuncio {
  arrowColor?: string;
  bgContainerAnuncios?: string;
}
export const ItemSpan = styled.div`
  width: 100%;
  background-color: ${(p: ItemProps) => p.bg && p.bg};
  &:hover {
    background-color: ${(p: ItemProps) => p.hover && p.hover};
  }
`;

export const DivContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  background-color: ${(p: PropsAnuncio) =>
    p.bgContainerAnuncios || "transparent"};
  .swiper-button-prev,
  .swiper-button-next {
    .icons {
      font-size: 80px;
    }
    color: ${(p: PropsAnuncio) => p.arrowColor || "#3C3B39"};
    padding: 0;
    margin: 0;
    &.swiper-button-disabled {
      opacity: 0.45;
      cursor: auto;
      pointer-events: none;
    }
    &.swiper-button-hidden {
      opacity: 0;
      cursor: auto;
      pointer-events: none;
    }
    .swiper-navigation-disabled & {
      display: none !important;
    }
  }

  @media (max-width: 780px) {
    .swiper-button-prev,
    .swiper-button-next {
      .icons {
        font-size: 30px;
      }
    }
  }
`;

export const SwiperContainer = styled(Swiper)`
  width: 90%;
  max-height: 50vh !important;
  @media (max-width: 780px) {
    max-height: 25vh !important;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-slide img {
    display: block;
    width: 90%;
    height: 90%;
    object-fit: fill;
  }
`;
